import { pink, primary, yellow, green } from '@/util/style';
import advarsel from '../assets/advarsel.svg';
// import store from '@/store';
// import cykelstier from '@/data/herning_cykelstier_osm.json';

import busMarker from '../assets/markers/bus.svg';
import railMarker from '../assets/markers/rail.svg';
import walkMarker from '../assets/markers/walk.svg';
import bicycleMarker from '../assets/markers/bicycle.svg';

export function loadLayers(map) {
  // Finner første symbollag for at placere
  // enkelte lag under labels
  const layers = map.getStyle().layers;
  let firstSymbolId;
  for (let i = 0; i < layers.length; i++) {
    if (layers[i].type === 'symbol' && layers[i].id.indexOf('highway') > -1) {
      firstSymbolId = layers[i].id;
      break;
    }
  }
  addCykelstiLayer(map, firstSymbolId);
  addItineraryLayer(map, firstSymbolId);
  // addSortPletLayer(map);
  // addTrafikfarligeSkolevejeLayer(map);
  addBusStopsLayer(map);
  addLegChangeLayer(map);
  addAdvarselLayer(map);
  addStepClickLayer(map);
}
export function addItineraryLayer(map, firstSymbolId) {
  map.addSource('itinerary', {
    type: 'geojson',
    data: {
      type: 'FeatureCollection',
      features: [],
    },
  });
  map.addLayer(
    {
      id: 'itinerary-blur',
      type: 'line',
      source: 'itinerary',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      paint: {
        'line-width': 6,
        'line-blur': 4,
        'line-color': '#FFFFFF',
      },
    },
    firstSymbolId
  );

  // map.addLayer({
  //   id: 'itinerary-outline',
  //   type: 'line',
  //   source: 'itinerary',
  //   layout: {
  //     'line-cap': 'round',
  //     'line-join': 'round',
  //   },
  //   paint: {
  //     'line-width': 6,
  //     'line-color': [
  //       'match',
  //       ['get', 'mode'],
  //       'WALK',
  //       pink[900],
  //       'BUS',
  //       yellow[900],
  //       'RAIL',
  //       green[900],
  //       primary[900], // default
  //     ],
  //   },
  // });

  map.addLayer(
    {
      id: 'itinerary',
      type: 'line',
      source: 'itinerary',
      filter: ['all', ['!=', 'mode', 'WALK']],
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      paint: {
        'line-width': 4,
        // Use a get expression (https://www.mapbox.com/mapbox-gl-js/style-spec/#expressions-get)
        // to set the line-color to a feature property value.
        'line-color': [
          'match',
          ['get', 'mode'],
          'BICYCLE',
          pink[500],
          'BUS',
          yellow[500],
          'RAIL',
          green[500],
          primary[500], // default
        ],
      },
    },
    firstSymbolId
  );

  // eget lag for gange
  map.addLayer(
    {
      id: 'itinerary-walk',
      type: 'line',
      source: 'itinerary',
      filter: ['all', ['==', 'mode', 'WALK']],
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      paint: {
        'line-width': 2,
        'line-color': primary[800],
        'line-dasharray': [2, 2],
      },
    },
    firstSymbolId
  );
}

// export function addSortPletLayer(map) {
//   map.addSource('sort-plet', {
//     type: 'geojson',
//     data: store.state.wfs
//       ? store.state.wfs.punkter.sortplet_kryds_2013
//       : {
//         type: 'FeatureCollection',
//         features: [],
//       },
//   });
//   map.addLayer({
//     id: 'sort-plet',
//     type: 'circle',
//     source: 'sort-plet',
//     paint: {
//       'circle-radius': 5,
//       'circle-color': '#FF020E',
//       'circle-opacity': 0,
//     },
//   });
// }

// export function addTrafikfarligeSkolevejeLayer(map) {
//   map.addSource('trafikfarlig-skolevej', {
//     type: 'geojson',
//     data: store.state.wfs
//       ? store.state.wfs.linjer.trafikfarlige_skoleveje
//       : {
//         type: 'FeatureCollection',
//         features: [],
//       },
//   });
//   map.addLayer({
//     id: 'trafikfarlig-skolevej',
//     type: 'line',
//     source: 'trafikfarlig-skolevej',
//     paint: {
//       'line-width': 6,
//       'line-color': '#FF020E',
//       'line-dasharray': [5, 1],
//       'line-opacity': 0,
//     },
//   });
// }

export function addAdvarselLayer(map) {
  let advarselImage = new Image(23, 20);
  advarselImage.onload = () => map.addImage('advarsel', advarselImage);
  advarselImage.src = advarsel;
  map.addSource('itinerary-advarsel', {
    type: 'geojson',
    data: {
      type: 'FeatureCollection',
      features: [],
    },
  });
  map.addLayer({
    id: 'itinerary-advarsel',
    type: 'symbol',
    layout: {
      'icon-image': 'advarsel',
      'icon-allow-overlap': true,
    },
    source: 'itinerary-advarsel',
  });
}

export function addCykelstiLayer(map, firstSymbolId) {
  map.addSource('itinerary-cykelsti', {
    type: 'geojson',
    data: {
      type: 'FeatureCollection',
      features: [],
    },
  });
  map.addLayer(
    {
      id: 'itinerary-cykelsti',
      type: 'line',
      source: 'itinerary-cykelsti',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      paint: {
        'line-width': ['interpolate', ['linear'], ['zoom'], 10, 8, 20, 30],
        // 'line-dasharray': [5, 1],
        // 'line-opacity': 0.3,
        'line-color': [
          'case',
          ['boolean', ['feature-state', 'hover'], false],
          '#F4C7DE',
          '#f793c6',
        ],
        // 'line-color': [
        //     'match',
        //   ['get', 'kode_vejtype_cykelsti'],
        //   '1',
        //   'red', // Cykelsti en vejside
        //   '2',
        //   '#f93e92', // Cykelsti to vejsider
        //   '3',
        //   '#f93e92', // Db.cykelsti en side
        //   '6',
        //   '#f93e92', // Cykelsti eget trace
        //   '657_20',
        //   '#f93e92', // 657_Cykelbane to sider
        //   '657_21',
        //   '#f93e92', // 657_Cykelbane en sider
        //   /* other */ '#ccc',
        // ],
      },
    },
    firstSymbolId
  );
}

export function addLegChangeLayer(map) {
  let busMarkerImage = new Image(28, 28);
  busMarkerImage.onload = () => map.addImage('busMarker', busMarkerImage);
  busMarkerImage.src = busMarker;

  let railMarkerImage = new Image(28, 28);
  railMarkerImage.onload = () => map.addImage('railMarker', railMarkerImage);
  railMarkerImage.src = railMarker;

  let walkMarkermage = new Image(28, 28);
  walkMarkermage.onload = () => map.addImage('walkMarker', walkMarkermage);
  walkMarkermage.src = walkMarker;

  let bicycleMarkerImage = new Image(36, 36);
  bicycleMarkerImage.onload = () =>
    map.addImage('bicycleMarker', bicycleMarkerImage);
  bicycleMarkerImage.src = bicycleMarker;

  map.addSource('leg-change', {
    type: 'geojson',
    data: {
      type: 'FeatureCollection',
      features: [],
    },
  });
  map.addLayer({
    id: 'leg-change',
    type: 'symbol',
    layout: {
      'icon-image': [
        'match',
        ['get', 'mode'],
        'BICYCLE',
        'bicycleMarker',
        'BUS',
        'busMarker',
        'RAIL',
        'railMarker',
        'walkMarker', // default
      ],
      'icon-allow-overlap': true,
      'icon-offset': [0, -30],
    },
    source: 'leg-change',
  });
}

export function addBusStopsLayer(map) {
  map.addSource('bus-stops', {
    type: 'geojson',
    data: {
      type: 'FeatureCollection',
      features: [],
    },
  });
  map.addLayer({
    id: 'bus-stops',
    type: 'circle',
    source: 'bus-stops',
    paint: {
      'circle-radius': [
        'match',
        ['get', 'endPoint'],
        'true',
        11,
        7, // default
      ],
      'circle-color': yellow[500],
    },
  });
}

export function addStepClickLayer(map) {
  map.addSource('step-click', {
    type: 'geojson',
    data: {
      type: 'FeatureCollection',
      features: [],
    },
  });
  map.addLayer({
    id: 'step-click',
    type: 'circle',
    source: 'step-click',
    paint: {
      'circle-radius': 10,
      'circle-color': '#FFFFFF',
      'circle-stroke-width': 2,
      'circle-stroke-color': primary[700],
      // 'circle-blur': 0.5,
    },
  });
}

export const layerSources = {
  itinerary: 'itinerary',
  sortPlet: 'sort-plet',
  busStops: 'bus-stops',
  advarsel: 'itinerary-advarsel',
  legChange: 'leg-change',
  cykelsti: 'itinerary-cykelsti',
  stepClick: 'step-click',
};

export const layers = {
  itinerary: 'itinerary',
  itineraryBlur: 'itinerary-blur',
  itineraryWalk: 'itinerary-walk',
  sortPlet: 'sort-plet',
  busStops: 'bus-stops',
  advarsel: 'itinerary-advarsel',
  legChange: 'leg-change',
  cykelsti: 'itinerary-cykelsti',
  stepClick: 'step-click',
};
